var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[_c('div',{staticClass:"switch_button"},[_c('div',{staticClass:"switch_button-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('label',{staticClass:"switch_button-checkbox",on:{"click":_vm.change}},[_c('span',{class:{ 'checked': _vm.switched },attrs:{"checked":false}}),_c('span',{staticClass:"slider round"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }